import { z } from 'zod'

export default z.object({
  __typename: z.literal('CallReport').default('CallReport'),
  id: z.number(),
})
